module.exports = __webpack_public_path__ + "static/media/TT-Norms-Pro-Light.1b413af3.ttf";